import { features } from 'reactApp/mail-features';

/**
 * B2BCLOUD-6192
 */
export const accessTokenV2 = features.has('access-token-v2') || false;

/**
 * B2BCLOUD-6192
 * значение параметра resource в AuthClient из @vk-workspace/superapp-sdk/auth'
 */
export const WEBVIEW_OAUTH_TOKEN_RESOURCE = features.getAsString('webview-disk-oauth-token-resource', 'https://cloud.mail.ru');

/**
 * B2BCLOUD-6192
 * значение параметра oauthBaseUrl в AuthClient из @vk-workspace/superapp-sdk/auth'
 */
export const WEBVIEW_OAUTH_TOKEN_URL =
    features.getAsURL('webview-disk-oauth-token-api-url', 'https://corsapi.imgsmail.ru') || 'https://corsapi.imgsmail.ru';
